import { Percent } from '@mui/icons-material';
import { TextInputField } from '@shared/components';
import { useController, useFormContext } from 'react-hook-form';
import { useFreightTFunction } from '@retail/freight/i18n';
import { CreateFreightConditionSchema, EditFreightConditionSchema } from './freightConditionSchema';
import { formatPrice } from '@retail/products/utils';
import { useTranslation } from 'react-i18next';

export function FreightConditionPercentAddonInput() {
  const t = useFreightTFunction();
  const { i18n } = useTranslation();

  const { control } = useFormContext<CreateFreightConditionSchema, EditFreightConditionSchema>();
  const percentAddonController = useController({ name: 'percentAddon', control });

  const freightPercentAddonValue = percentAddonController.field.value
    ? formatPrice(percentAddonController.field.value, i18n.language)
    : '';

  return (
    <TextInputField
      {...percentAddonController.field}
      value={freightPercentAddonValue}
      error={percentAddonController.fieldState.error?.message}
      margin="none"
      required
      label={t('freight.form.percent')}
      size="small"
      inputSx={{ width: 400 }}
      placeholder={t('freight.actions.writePercentAddonSurcharge')}
      endAdornment={<Percent />}
      onChange={(e) => {
        const value = e.target.value;
        percentAddonController.field.onChange(value);
      }}
    />
  );
}
